import { Link } from 'react-router-dom';
import { contactData } from '@/mocks/homeData';

const footerLinks = [
  {
    title: '服务项目',
    links: [
      { label: '文件起草服务', path: '/category/wenjian-qicao' },
      { label: '官网建设服务', path: '/category/guanwang-jianshe' },
      { label: '法律文书服务', path: '/category/falv-wenshu' },
      { label: '商业合同服务', path: '/category/shangye-hetong' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { label: '品牌介绍', path: '/about' },
      { label: '发展历程', path: '/about#timeline' },
      { label: '资质信誉', path: '/about#credentials' },
      { label: '联系我们', path: '/about#contact' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', path: '/#faq' },
      { label: '服务流程', path: '/category/hangye-zixun' },
      { label: '行业资讯', path: '/category/hangye-zixun' },
      { label: '用户协议', path: '/' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-2xl font-bold text-primary-400 font-heading">17.c</span>
              <span className="text-sm text-background-300 ml-1 font-heading">起草官网</span>
            </Link>
            <p className="text-sm text-background-300 leading-relaxed mb-4">
              专业文件起草与官网建设一站式服务平台。为企业提供高效、规范的文件起草解决方案，助力企业快速搭建权威官方网站。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-background-100 mb-4">{group.title}</h4>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-background-300 hover:text-primary-400 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-300/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-wrap items-center gap-4 text-sm text-background-400">
            <span>© 2025 17.c 起草官网</span>
            <span className="hidden sm:inline">|</span>
            <span>{contactData.phone}</span>
            <span className="hidden sm:inline">|</span>
            <span>{contactData.email}</span>
          </div>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg" />
            </a>
            <a href="#" className="text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg" />
            </a>
            <a href="#" className="text-background-300 hover:text-primary-400 transition-colors cursor-pointer" aria-label="邮箱">
              <i className="ri-mail-line text-lg" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}